import React from 'react';

import { Benefit } from '@/@types/benefits';
import { BenefitModalProps } from '@/@types/benefitModalProps';
import { Modal } from '@/components/common/display/modal/Modal';
import { Msg, useIntl } from '@/i18n';
import AutoContactAgentVideo from './images/auto-contact-agent.webm';

const LEARN_MORE_URL = 'https://www.immobilienscout24.de/lp/bewerbungsassistent.html';

const OverviewTab = () => (
  <div style={{ maxWidth: 530 }}>
    <p className='font-heading-xsmall-regular padding-bottom-l'>
      <Msg
        id='benefits.autoContactAgent.modal.paragraph1'
        defaultMessage='Mit dem Bewerbungsassistenten legst du fest, was du suchst – den Rest machen wir.'
      />
    </p>
    <p className='padding-bottom-l'>
      <Msg
        id='benefits.autoContactAgent.modal.paragraph2'
        defaultMessage='Der Bewerbungsassistent prüft laufend passende neue Inserate passend zu deinen Suchkriterien und versendet automatisch Anfragen für dich. So sicherst du dir den Vorsprung, sobald eine passende Wohnung online geht.'
      />
    </p>
    <p>
      <Msg
        id='benefits.autoContactAgent.modal.paragraph3'
        defaultMessage='Du behältst die volle Kontrolle, deine Suche kannst du jederzeit anpassen oder pausieren.'
      />
    </p>
  </div>
);

export const AutoContactAgent = ({ isVisible, onClose }: BenefitModalProps) => {
  const { t } = useIntl();

  return (
    <Modal
      title={t({ id: 'benefits.autoContactAgent.headline' })}
      isVisible={isVisible}
      image={AutoContactAgentVideo}
      imageUseFullWidth={false}
      imageAlt={t({ id: 'benefits.autoContactAgent.modal.image' })}
      video={AutoContactAgentVideo}
      tabsContent={[<OverviewTab key='benefits.autoContactAgent.modal.overview' />]}
      benefit={Benefit.AUTO_CONTACT_AGENT}
      buttonArea={
        <div className='align-center'>
          <a className='button-secondary button-rounded' href={LEARN_MORE_URL}>
            <Msg id='benefits.autoContactAgent.modal.learnMore' defaultMessage='Mehr erfahren' />
          </a>
        </div>
      }
      onClose={onClose}
    />
  );
};
